export default __webpack_public_path__ + "static/Washington-4b8f53cf809ac9dd7ca6af9eb5f31859.svg";